import { createAction } from 'redux-actions';

export const fetchResourceOperations = createAction('FETCH_RESOURCE_OPERATIONS');
export const fetchResourceOperationsSuccess = createAction('FETCH_RESOURCE_OPERATIONS_SUCCESS');
export const fetchResourceOperationsFailure = createAction('FETCH_RESOURCE_OPERATIONS_FAILURE');

export const clearResourceOperationsState = createAction('CLEAR_RESOURCE_OPERATIONS_STATE');
export const reorderOperationProps = createAction('REORDER_OPERATION_PROPS');

export const reorderOperations = createAction("REORDER_OPERATIONS");
export const reorderOperationsSuccess = createAction("REORDER_OPERATIONS_SUCCESS");
export const reorderOperationsFailure = createAction("REORDER_OPERATIONS_FAILURE");

